export const firebaseConfig = {
  apiKey: "AIzaSyCkdYGAVJpzQmGe_gmg6hbWmqqzm28ZqDU",
  authDomain: "infoauto-app.firebaseapp.com",
  projectId: "infoauto-app",
  storageBucket: "infoauto-app.appspot.com",
  messagingSenderId: "976062209161",
  appId: "1:976062209161:web:573c9f894e6f3364737a58",
  measurementId: "G-SF5EH6ZEKT",
};
